import { useState } from 'react'
import { FaSignInAlt, FaSignOutAlt, FaUser } from 'react-icons/fa';
import { FaPlusCircle } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout, reset as authSliceReset } from '../features/auth/authSlice';
import { reset as sensorSliceReset, resetStatus } from '../features/sensors/sensorSlice';
import { reset as outputStateSliceReset } from '../features/outputState/outputStateSlice';
import { Button, Row, Col, Form, Modal, Container } from 'react-bootstrap';
import { connect } from '../features/sensors/sensorSlice';
import { toast } from 'react-toastify';
import toastConfig from '../app/toast-config';

function Header() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { devices, currentDevice, sensorData, isUserDevicesLoading, isSensorDataLoading, isConnectionLoading, isError, isSuccess, message } = useSelector((state) => state.deviceData);
    const [show, setShow] = useState(false);
    const [ deviceId, setdeviceId ] = useState('')
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const onLogout = () => {
        dispatch(logout());
        dispatch(authSliceReset());
        dispatch(sensorSliceReset());
        dispatch(outputStateSliceReset());
        navigate('/login');
    };

    const connectDevice = () => {
        dispatch(resetStatus());
        const userId = user._id;
        const data = {
            deviceId,
            userId
        }
        console.log(`Trying to connect you with device ${deviceId}...`);
        dispatch(connect(data));
    }

    return (<>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Connect a new device</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3 pt-2" controlId="exampleForm.ControlInput1">
                    {isConnectionLoading ? (<>
                        <Container className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden"></span>
                            </div>
                            <p>Connecting...</p>
                        </Container>
                    </>) : (<>
                        {/* <Form.Label>ID</Form.Label> */}
                        <Form.Control
                            type="text"
                            placeholder="Device Id"
                            autoFocus
                            onChange={e => setdeviceId(e.target.value)}
                        />
                    </>)}
                    </Form.Group>
                </Form>
            </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="success" onClick={connectDevice} disabled={isConnectionLoading}>
            Connect
          </Button>
        </Modal.Footer>
      </Modal>
                        
    <Row className="header justify-content-center my-2">
        <Col md="auto" className="text-center dashboard-link"> 
            <h3 className="display-4">
                <Link to='/'>
                    <span>
                        <img className="img-fluid logo" src="https://www.iconpacks.net/icons/2/free-leaves-icon-1571-thumb.png" alt="PlantIT logo" />
                    </span>
                    PlantIT Dashboard
                </Link>
            </h3>
        </Col>
        {user ? (<>
            <Col md="auto" className="text-center">
                <Button variant="dark" className="btn-custom btn-first-auth" onClick={handleShow}>
                    <Container className='d-flex align-items-center px-0'>
                        <FaPlusCircle/> Connect device
                    </Container>
                </Button>
                <Button variant="dark" className="btn-custom btn-second-auth px-0" onClick={onLogout}>
                    <Container className='d-flex align-items-center'>
                        <FaSignOutAlt/> Logout
                    </Container>
                </Button>
            </Col>
            <Col md="auto" className="text-center">
                <span className="mx-2">Logged in as {user.name}</span>
            </Col>
        </>) : (<>
            <Col md="auto" className="text-center">
                <Link to='/login' className="btn btn-custom btn-first-no-auth">
                    <Container className='d-flex align-items-center px-0'>
                        <FaSignInAlt/> Login
                    </Container>
                </Link>

                <Link to='/register' className="btn btn-custom btn-second-no-auth">
                    <Container className='d-flex align-items-center px-0'>
                        <FaUser/> Register
                    </Container>
                </Link>
            </Col>
        </>)}
    </Row>
  </>)
}

export default Header